module.exports = __webpack_public_path__ + "static/media/HYUNDAI.7575ae16.svg";